import { useMemo } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { QuestionType } from 'cat-shared/utils'
import { AppFormAutoComplete, AppFormSelect } from 'client/ui-building-blocks'

type Props = {
  isLoading: boolean
}

const CorrectOptionsAutocomplete = ({ isLoading }: Props) => {
  const { t } = useTranslation()

  const {
    control,
    formState: { errors },
    getValues,
  } = useFormContext()

  const { type, numOfOptions } = getValues()

  const OPTIONS = useMemo(() => {
    return Array.from({ length: numOfOptions }, (v: unknown, k: number) => ({
      value: String(k),
      text: t('createQuestionPage.fields.answerNumber', { n: k + 1 }),
    }))
  }, [numOfOptions, t])

  return (
    <Controller
      control={control}
      name="correctOptions"
      rules={{
        required: t('common.validation.required'),
      }}
      render={({ field: { value, onChange } }) => {
        if (type === QuestionType.SingleChoice) {
          return (
            <AppFormSelect
              value={!value.length ? '' : value[0]}
              options={OPTIONS || []}
              label={t('createQuestionPage.fields.correctOptions.label')}
              placeholder={t('createQuestionPage.fields.correctOptions.placeholder1')}
              disabled={isLoading}
              onChange={onChange}
              error={String(errors.correctOptions?.message || '')}
            />
          )
        } else {
          return (
            <AppFormAutoComplete
              value={value}
              options={OPTIONS || []}
              label={t('createQuestionPage.fields.correctOptions.label')}
              placeholder={t('createQuestionPage.fields.correctOptions.placeholder2')}
              disabled={isLoading}
              onChange={onChange}
              multiple
              search={false}
              error={String(errors.correctOptions?.message || '')}
            />
          )
        }
      }}
    />
  )
}

export default CorrectOptionsAutocomplete
